export default __webpack_public_path__ + "static/conferenceLeagueFlag-8379a64e338ad1971f82b35d267923f5.svg";